<!--
  Confirm Complete — small Diakonix confirm sub-modal.
  Redesigned 2026-06-12 (v2.7.0, Phase 1.5 Chunk D.3).

  Opened from the ordini-da-firmare list when the user clicks
  "Completa" on a row. Emits modalClosed on Yes (the parent
  triggers the API call to mark the order completed).

  Drops kendo-dialog + kendo-overlay + ~10 inline styles.
  Diakonix modal--sm pattern (max-width 480px, z-index 2050 above
  the dettagli modal at 2000 in case both are open).
-->

@if (modalOpened) {
  <div class="modal-backdrop" (click)="onNoClick()">
    <aside
      class="modal modal--sm"
      role="alertdialog"
      aria-labelledby="confirm-complete-title"
      (click)="$event.stopPropagation()"
    >

      <header class="modal__header">
        <span class="modal__icon" aria-hidden="true">⚠️</span>
        <h2 class="modal__title" id="confirm-complete-title">
          Concludere l'ordine?
        </h2>
      </header>

      <div class="modal__body">
        <p class="modal__message">
          Questa azione è <strong>irreversibile</strong>.
          Sei sicuro di voler concludere l'ordine
          @if (order_id && order_id !== '-1') {
            <span class="modal__order-tag">N° {{ order_id }}</span>
          }
          ?
        </p>
      </div>

      <footer class="modal__footer">
        <button
          type="button"
          class="btn btn--ghost"
          (click)="onNoClick()"
        >✖ Annulla</button>
        <button
          type="button"
          class="btn btn--primary"
          (click)="onYesClick()"
          autofocus
        >✓ Concludi</button>
      </footer>

    </aside>
  </div>
}
